
import React from "react";
import { Badge } from "@/components/ui/badge";
import { ValidationStage } from "@/services/agent/agent-validation-service";

interface ValidationStatusProps {
  stage: ValidationStage;
  passed: boolean;
}

/**
 * Component to display file validation status with appropriate styling
 */
const FileValidationStatus: React.FC<ValidationStatusProps> = ({ stage, passed }) => {
  // Determine badge variant based on validation status
  const getBadgeVariant = () => {
    if (stage === ValidationStage.APPROVED) return "success";
    if (stage === ValidationStage.REJECTED) return "destructive";
    if (!passed) return "destructive";
    if (stage === ValidationStage.QUARANTINE) return "warning";
    return "secondary";
  };

  // Get human-readable status text
  const getStatusText = () => {
    const stageDisplay = stage.replace(/_/g, ' ');
    return `${passed ? 'Passed' : 'Failed'}: ${stageDisplay.charAt(0).toUpperCase() + stageDisplay.slice(1)}`;
  };

  // Get appropriate icon based on stage and status
  const getIcon = () => {
    if (stage === ValidationStage.RECEIVED) return "📥";
    if (stage === ValidationStage.EXTENSION_SIZE_CHECK) return passed ? "✓" : "⚠️";
    if (stage === ValidationStage.VIRUS_SCAN) return passed ? "🛡️" : "🦠";
    if (stage === ValidationStage.STRUCTURE_VALIDATION) return passed ? "🔍✓" : "🔍✗";
    if (stage === ValidationStage.QUARANTINE) return "🔒";
    if (stage === ValidationStage.APPROVED) return "✅";
    if (stage === ValidationStage.REJECTED) return "❌";
    return passed ? "✓" : "✗";
  };

  return (
    <Badge variant={getBadgeVariant() as any} className="py-1 px-3">
      <span className="mr-1">{getIcon()}</span>
      {getStatusText()}
    </Badge>
  );
};

export default FileValidationStatus;
